// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"save-content_wrapper__35eRI","container":"save-content_container__3oiCW"};